import { salesApi } from '../config/apiClient';
import { SALES_API } from '../config/api';

// ========== Types ==========

export interface ClubEntryPackageItemDto {
  id?: number;
  productId?: string | null;
  productName: string;
  quantity: number;
  sortOrder?: number;
}

export interface ClubEntryPackageDto {
  id: number;
  quickSaleScreenId: number;
  name: string;
  color?: string | null;
  imageUrl?: string | null;
  sortOrder: number;
  items: ClubEntryPackageItemDto[];
}

export interface CreateClubEntryPackageItemDto {
  productId?: string | null;
  productName: string;
  quantity: number;
  sortOrder?: number;
}

export interface CreateClubEntryPackageDto {
  quickSaleScreenId: number;
  name: string;
  color?: string | null;
  imageUrl?: string | null;
  sortOrder?: number;
  items: CreateClubEntryPackageItemDto[];
}

export interface UpdateClubEntryPackageDto {
  name: string;
  color?: string | null;
  imageUrl?: string | null;
  sortOrder?: number;
  items: CreateClubEntryPackageItemDto[];
}

// ========== Helpers ==========

function toCamelCase(obj: any): any {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(toCamelCase);
  const result: any = {};
  for (const key of Object.keys(obj)) {
    const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
    result[camelKey] = toCamelCase(obj[key]);
  }
  return result;
}

// ========== Service ==========

export const clubEntryPackageService = {
  async getPackages(screenId: number): Promise<ClubEntryPackageDto[]> {
    const response = await salesApi.get(SALES_API.CLUB_ENTRY_PACKAGES(screenId));
    const raw = toCamelCase(response.data);
    return Array.isArray(raw) ? raw : [];
  },

  async createPackage(dto: CreateClubEntryPackageDto): Promise<ClubEntryPackageDto> {
    const response = await salesApi.post(SALES_API.CLUB_ENTRY_PACKAGE_CREATE, dto);
    return toCamelCase(response.data);
  },

  async updatePackage(id: number, dto: UpdateClubEntryPackageDto): Promise<ClubEntryPackageDto> {
    const response = await salesApi.put(SALES_API.CLUB_ENTRY_PACKAGE_UPDATE(id), dto);
    return toCamelCase(response.data);
  },

  async deletePackage(id: number): Promise<void> {
    await salesApi.delete(SALES_API.CLUB_ENTRY_PACKAGE_DELETE(id));
  },
};
